var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c(_setup.PageTitle,{attrs:{"main":_vm.$t('editIndicators'),"sub":"","imagem":"editInd.png"}}),_c(_setup.TabStructure,{attrs:{"isCreating":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }